let variableSeq = 0

export const cssVar = <T = string | number>(name: PropertyKey) => {
  const fullName = `${name.toString()}_${variableSeq}`
  variableSeq += 1

  return {
    get(defaultValue?: string | number) {
      return defaultValue ? `var(--${fullName}, ${defaultValue})` : `var(--${fullName})`
    },
    set(newValue: T) {
      return `--${fullName}: ${typeof newValue === 'function' ? newValue() : newValue || 'unset'}`
    },
  }
}
